/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckExpiryDateGteMismatch, PaxCheckExpiryDateGteMismatchFromJSONTyped, PaxCheckExpiryDateGteMismatchToJSON } from "./PaxCheckExpiryDateGteMismatch";
import { PaxCheckFieldMismatch, PaxCheckFieldMismatchFromJSONTyped, PaxCheckFieldMismatchToJSON } from "./PaxCheckFieldMismatch";
import { PaxCheckNationalityInMismatch, PaxCheckNationalityInMismatchFromJSONTyped, PaxCheckNationalityInMismatchToJSON } from "./PaxCheckNationalityInMismatch";


/**
 * @type PaxCheckRulesMismatch
 * 
 * @export
 */
export type PaxCheckRulesMismatch = { type: 'expiry-date-gte-mismatch' } & PaxCheckExpiryDateGteMismatch | { type: 'field-mismatch' } & PaxCheckFieldMismatch | { type: 'nationality-in-mismatch' } & PaxCheckNationalityInMismatch;

export function PaxCheckRulesMismatchFromJSON(json: any): PaxCheckRulesMismatch {
    return PaxCheckRulesMismatchFromJSONTyped(json, false);
}

export function PaxCheckRulesMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRulesMismatch {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'expiry-date-gte-mismatch':
            return Object.assign({}, PaxCheckExpiryDateGteMismatchFromJSONTyped(json, true), { type: 'expiry-date-gte-mismatch' } as const);
        case 'field-mismatch':
            return Object.assign({}, PaxCheckFieldMismatchFromJSONTyped(json, true), { type: 'field-mismatch' } as const);
        case 'nationality-in-mismatch':
            return Object.assign({}, PaxCheckNationalityInMismatchFromJSONTyped(json, true), { type: 'nationality-in-mismatch' } as const);
        default:
            return json;
    }
}

export function PaxCheckRulesMismatchToJSON(json: any): any {
    return PaxCheckRulesMismatchToJSONTyped(json, false);
}

export function PaxCheckRulesMismatchToJSONTyped(value?: PaxCheckRulesMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'expiry-date-gte-mismatch':
            return Object.assign({}, PaxCheckExpiryDateGteMismatchToJSON(value), { type: 'expiry-date-gte-mismatch' } as const);
        case 'field-mismatch':
            return Object.assign({}, PaxCheckFieldMismatchToJSON(value), { type: 'field-mismatch' } as const);
        case 'nationality-in-mismatch':
            return Object.assign({}, PaxCheckNationalityInMismatchToJSON(value), { type: 'nationality-in-mismatch' } as const);
        default:
            return value;
    }
}

